module.exports = __webpack_public_path__ + "static/IronCAP logo black (480 x 110)-ce44c7c7fbc1ba35f7f8f446f300000d.png";